// Resize font
const maxFontSize = 20
const minFontSize = 14
const baseFontSize = 16
const fontSizeKey = 'fontSize'
let currentFontSize = 16
if(sessionStorage.getItem(fontSizeKey)) {
  currentFontSize = Number(sessionStorage.getItem(fontSizeKey));
}

const fontInit = () => {
  const increase = document.getElementById('increaseFont')
  if (increase) {
    increase.addEventListener('click', () => {
      setFontSize(currentFontSize + 2)
    })
  }
  const decrease = document.getElementById('decreaseFont')
  if (decrease) {
    decrease.addEventListener('click', () => {
      setFontSize(currentFontSize - 2)
    })
  }
  const small = document.getElementById('smallFont')
  if (small) {
    small.addEventListener('click', () => {
      setFontSize(minFontSize)
    })
  }
  const large = document.getElementById('largeFont')
  if (large) {
    large.addEventListener('click', () => {
      setFontSize(maxFontSize)
    })
  }
  const reset = document.getElementById('resetFont')
  if (reset) {
    reset.addEventListener('click', () => {
      setFontSize(baseFontSize)
    })
  }

}

const setFontSize = (size) => {
  if (size < minFontSize) {
    size = minFontSize
  }
  if (size > maxFontSize) {
    size = maxFontSize
  }
  currentFontSize = size
  sessionStorage.setItem(fontSizeKey, currentFontSize);
  document.documentElement.style.fontSize = currentFontSize + 'px' ;
}

setFontSize(currentFontSize)

window.addEventListener('load', fontInit)
